import axios from "axios";
import { ApiError, type ApiFailure, type ProblemDetails } from "@/types/api";

/** Normalizes once, after session fencing and 401 handling; ignores unstructured response bodies. */
export function normalizeApiError(error: unknown): ApiFailure {
  if (axios.isCancel(error) || error instanceof ApiError) return error;
  if (!axios.isAxiosError<unknown>(error)) return new ApiError("unexpected");
  if (error.response) {
    const data = error.response.data;
    const problem: ProblemDetails = {};
    if (typeof data === "object" && data !== null && !Array.isArray(data)) {
      for (const key of ["type", "title", "detail", "instance"] as const) {
        const value = Reflect.get(data, key);
        if (typeof value === "string") problem[key] = value;
      }
    }
    return new ApiError("http", error.response.status, problem);
  }
  return new ApiError(
    error.code === "ECONNABORTED" || error.code === "ETIMEDOUT"
      ? "timeout"
      : "network",
  );
}
